const OVERVIEW_STEPS = [
  {
    number: 1,
    title: "Work Experience",
    description:
      "You must have a minimum 3 years as a full-time design professional. You will also need start dates and end dates for each role in your designer journey.",
  },
  {
    number: 2,
    title: "Education & Certifications",
    description:
      "Share any relevant degrees or certifications you have. If you do not have any, you may leave this section blank.",
  },
  {
    number: 3,
    title: "Professional References",
    description:
      "You will need contact information in the form of an email and phone number for each reference provided. You must provide two professional and two client references.",
  },
  {
    number: 4,
    title: "Business Goals",
    description:
      "We want to learn more about the vision and goals for your business to provide the best possible ongoing support.",
  },
  {
    number: 5,
    title: "Membership Selection",
    description:
      "Select which membership tier you are most interested in. You will not be committed to this selection in any way.",
  },
] as const;

export const DesignerWelcomePopupPageTwo = () => {
  return (
    <div className="designer-welcome-popup-page designer-welcome-popup-page--overview">
      <p className="designer-welcome-popup-copy font-size-4">
        Before you begin your journey to become a certified interior designer
        with Home Design Guild, please review our application process carefully.
        This will help you prepare all necessary documents and understand
        associated costs.
      </p>
      <div className="designer-welcome-popup-overview-list">
        {OVERVIEW_STEPS.map((step) => (
          <div className="designer-welcome-popup-overview-item" key={step.number}>
            <span className="designer-welcome-popup-number">{step.number}</span>
            <div className="designer-welcome-popup-overview-copy">
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
